<template>
    <s-modal
            :title="club.id==null ? 'Créer votre club' : 'Modifier un club'"
            :open="open"
            :close="true"
            @close="$emit('close')"
            :save="true"
            @save="save"
            :deleteData="!clubIsSubscription"
            @delete="confirmDeleteClub=true"
            :info="infoModal"
    >
   
                  
                  
        <s-confirm
            :open="confirmDeleteClub"
            @yes="deleteClub"
            @no="confirmDeleteClub=false"
        >
            <s-l id="confirmDeleteClub">Confirmez la suppression de ce club ?<br/>Attention, cela supprimer défnitivement les membres, les tournois et les saisons de votre club ?</s-l>
        </s-confirm>
               
        <div>
            <div class="field">
                <div class="formLabel">
                    <s-l id="club_name">Nom de votre club :</s-l>
                </div>
                <s-input theme="is-normal is-danger" placeholder="Nom du club" v-model="club.name"
                    @blur="changeData" width="300px" />
                    <div class="idDynamique">
                        {{urlClub}}
                    </div>
                    <span class="errorExist" v-show="errorExist">
                        <s-l id="club_errorExist">Désolé ce nom de club existe déjà !</s-l>
                    </span>
                    <span class="errorExist" v-show="errorLength">
                        <s-l id="club_errorLength">Le nom du club doit être supérieur à 3 caractères</s-l>
                    </span>
            </div>
            <div class="field">
                <div class="formLabel">
                    <s-l id="club_namepresident">Nom du président :</s-l>
                </div>
                <s-input theme="is-normal is-info" width="300px" @change="changeData" placeholder="nom du président" v-model="club.president"/>
             </div>
            <div class="field">
                <div class="formLabel">
                    <s-l id="club_tel">Téléphone du club :</s-l>
                </div>
                <s-input theme="is-normal is-info"  width="300px" @change="changeData" placeholder="téléphone du club" v-model="club.tel"/>
            </div>
            <div class="field">
                <div class="formLabel">
                    <s-l id="club_type">Type du club :</s-l>
                </div>
                <div style="text-align:center">
                    <div class="buttonsType">
                    <s-button 
                        icon="child"
                        label="entre amis ou Familliale"
                        :theme="club.type==0 ? 'is-success is-normal' : 'is-light is-normal'"
                        @onclick="setType(0)"
                    />
                    </div>
                    &nbsp;
                    <div class="buttonsType">
                    <s-button 
                        icon="umbrella-beach"
                        label="Club de vacance"
                        :theme="club.type==1 ? 'is-success is-normal' : 'is-light is-normal'"
                        @onclick="setType(1)"
                    />
                     </div>
                      &nbsp;
                      <div class="buttonsType">
                    <s-button 
                        icon="basketball-ball"
                        label="Amateur"
                        :theme="club.type==2 ? 'is-success is-normal' : 'is-light is-normal'"
                        @onclick="setType(2)"
                    />
                      </div>  &nbsp;
                       <div class="buttonsType">
                     <s-button 
                        icon="user-tie"
                        label="Licencié"
                       :theme="club.type==3 ? 'is-success is-normal' : 'is-light is-normal'"
                        @onclick="setType(3)"
                    /> 
                     </div>
                </div>
            </div>
            <div class="field"  v-show="club.type==3">
                <div class="formLabel">
                    <s-l id="club_comite">Comité du club :</s-l>
                </div>
                <s-input  @blur="changeData" width="100px" theme=" is-info" v-model="club.comite" />
            </div>
             <div class="field"  v-show="club.type==3">
                <div class="formLabel">
                    <s-l id="club_number">Numero du club :</s-l>
                </div>
                <s-input  @blur="changeData"  theme=" is-info" v-model="club.numero"   width="100px" />
            </div>
            <div class="field">
                <div class="formLabel">
                    <s-l id="club_link">Lien internet du club :</s-l>
                </div>
                <s-input theme="is-medium is-info" @change="changeData" placeholder="www." v-model="club.urlsite"/>
            </div>
            <div class="field">         
                    <div class="formLabel">
                        <s-l id="club_description">Description du club :</s-l>
                    </div>
                    <textarea 
                        v-model="club.description" cols="80" rows="3" class="textarea is-info"
                        maxlength="100"
                        placeholder="100 caractères au maximum"
                        @blur ="changeData"
                    /><br/>
                     
            </div>
            
        </div>
        <s-confirm
            :open="openIdConfirm"
            @no="openIdConfirm=false"
            @yes="save"
        >
            <s-l id="club_confirmId">
                L'adresse de votre site a été calculé en fonction du nom de votre club.<br/>
            </s-l>
            <div style="text-align:center;font-weight: bolder">
                {{urlClub}}
            </div>
            <s-l id="club_confirmId2">
                Vous pourrez toujours modifier le nom de votre club, mais l'adresse ne pourra plus être modifié.<br/>
                Confirmez vous la création de ce  club ?
            </s-l>
        </s-confirm>
    </s-modal>
</template>
<style scoped>
    .field {
        margin-top: 10px;
    }
    .formLabel {
        width:170px;
        display:inline-block;
        vertical-align: middle;
        font-weight: bolder;
        text-align:left;
    }
    .errorDelete {
        font-size: 13px;
        color: red;
    }
    .membre {
        padding-left: 10px;
        padding-bottom: 10px;
    }
    #map {
        width: 100%;
        border-radius: 20px;
        font-size: 14px;
       
    }
    .save {
        font-style: italic;
        color: rgb(11, 94, 11);
    }
    .idDynamique {
        font-size: 12px;
        padding-left: 20px;
        font-style: italic;
        margin-top: 10px;
    }
    input[type=checkbox] {
    transform: scale(2);
    }
    .buttonsType {
        margin-bottom: 10px;
        width: 260px;
        display: inline-block;
    }
    .errorExist {
        font-size: 12px;
        font-style: italic;
        color: rgb(185, 21, 21);
    }
    .clubId {
        border: thin black solid;
        padding: 3px;
        color: silver;
    }
    .caracteristique {
        width: 100%;
        min-width: 350px;
        display: inline-block;
        border: solid silver thin;
        padding: 10px;
        margin-right: 20px;
        margin-bottom: 20px;
    }
    .edit {
        padding-left: 20px;
        vertical-align: top;
        
    }
   
</style>
<script>
import club_fct from "@/firebase/club"

import firebase from "firebase/app"

export default {
    props:["club","role", "open"],
    data() {
        return {
            openIdConfirm: false,
            newClub: true,
            errorExist: false,
            errorLength: false,
            buttonDisabledSave: false,
            confirmDeleteClub: false
        }
    },
   
    computed: {
        infoModal() {
            if (this.clubIsSubscription) {
                return "Ce club ne peut pas être supprimé car il y a un abonnement encore actif..."
            }
            else
                return false;
        },
        clubIsSubscription() {
            if (typeof(this.club.subscription) != "undefined")
                    if (this.club.subscription.status == "active") {
                        var date = new Date();
                        var endDate = this.club.subscription.period_end.toDate();
                        var startDate =  this.club.subscription.period_start.toDate();
                        endDate.setDate(endDate.getDate() + 7);
                        if (startDate < date && date < endDate)
                            return true;
                        else
                            return false;
                    }
                    else
                        return false;
                else
                    false;
        },
        clubId() {
            
            if (this.club.length != 0) {
                if (this.club.id == null) {
                    if (this.club.name != "")
                        return (this.$StringToId(this.club.name).toLowerCase());
                    else   
                        return ""
                }
                else
                    return this.club.id;
            }
            else 
                return null;
        },
        urlClub: {
            get() {
                return window.origin + "/club/" + this.clubId;
            }
        }
    },
    methods: {
        changeData() {
            this.buttonDisabledSave = false;     
           
        },
         deleteClub() {
            club_fct.object.delete(this.club.id, ()=>{
                
                this.$router.push({name: "club"})
                .then(()=>{})
                .catch(error=>{
                });
            })
        },
        setType(type) {
            this.buttonDisabledSave = false;     
            this.club.type = type;
           
        },
        cancel() {
            this.$emit("close")
        },
        async save() {
            var execSave = false;
            var createClub = this.club.id == null;
            execSave = this.club.id != null;

            if (!execSave) {
                if (this.openIdConfirm)
                    execSave = true;
                else
                    this.openIdConfirm = true;
            }
            if (execSave) {
                this.errorExist = false;
                this.errorLength = false;    
                var user = {};
                user.authId = firebase.auth().currentUser.uid;
                user.pseudo = this.$store.getters.getUser.displayName;
                user.id = this.$store.getters.getUser.id;
                user.email = firebase.auth().currentUser.email;
                user.role = "owner";
                
                var result = await club_fct.object.save(this.club, user);
                if (result.success) {
                    this.buttonDisabledSave = true; 
                    this.openIdConfirm = false;
                    if (createClub)
                        this.$emit('close', this.club);
                    else
                        this.$emit('close');
                }
                else {
                    this.errorExist = result.errorExist;
                    this.errorLength = result.errorLength;
                    this.openIdConfirm = false;
                }
            }
        }
    },
    mounted() {
        this.newClub = (this.club.id == '')
    }
}
</script>